import React, { useEffect, useRef, useState, useContext } from "react";
import Admin_Table from "./Admin_Table";
import "../servicesOperation.css";
import { useNavigate } from "react-router-dom";
import Auth0Context from "contexts/Auth0Context";
import { ModalConfirmEventos_ServicesOperation } from "views/Components/ModalConfirmEventos_Services_Operation";
import Animation_Success_animation from "../Helper/Animation_Success_animation";
import { Alerta_Permisos_Services_Operation } from "views/Components/Alerta_Permisos_Services_Operation";
import Animation_Warning_animation from "../Helper/Animation_Warning";
import useAuth from "hooks/useAuth";
import { AppGlobalContext } from "contexts/GlobalContext";
import { Skeleton, Stack } from "@mui/material";
import StateFilterChip from "./Chip/StateFilterChip";
import DateFilterChip from "./Chip/DateFilterChip";
import useStateData from "../Queries/stateDataQuery";
import useAdminData from "../Queries/adminDataQuery";
import useBulkUpdateAdminFinMutation from "../Queries/bulkUpdateAdminFinMutation";
import { useBoundStore } from "useStore";
import Toolbar from "./Toolbar/Toolbar";
import SkeletonsAdminPage from "./SkeletonsAdminPage";

const Admin = () => {
  const { mainCountry } = useContext(AppGlobalContext);
  const [country, setCountry] = React.useState(mainCountry);
  const { accessToken } = useAuth();
  const { user } = useContext(Auth0Context);
  const navigate = useNavigate();

  const selectedStatus = useBoundStore((state) => state.soAdminSelectedStatus);
  const setSelectedStatus = useBoundStore(
    (state) => state.setSoAdminSelectedStatus,
  );

  const [selected, setSelected] = useState([]);
  const [dataTableHistory, setDataTableHistory] = useState([]);

  const isFirstRender = useRef(true);

  //Estados de los modales
  const [openModal, setOpenModal] = useState(false);
  const [openModalFinal, setOpenModalFinal] = useState(false);
  const [openModalWarning, setOpenModalWarning] = useState(false);
  const [messageWarning, setMessageWarning] = useState("");

  useEffect(() => {
    setCountry(mainCountry);
  }, [mainCountry]);

  // Reset al cambiar de país (no corre en el mount inicial)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setDataTableHistory([]);
    setSelectedStatus(null);
  }, [mainCountry]);

  useEffect(() => {
    setDataTableHistory([]);
  }, [selectedStatus]);

  // --- Queries ---
  const stateDataQuery = useStateData({ countryId: country.id });

  const adminDataQuery = useAdminData({
    countryId: country.id,
  });

  useEffect(() => {
    if (selectedStatus) {
      adminDataQuery.refetch({ cancelRefetch: false });
    }
  }, []);

  // Accumulate history for bulk update
  useEffect(() => {
    if (!adminDataQuery.data?.data) return;
    setDataTableHistory((prev) => {
      const toPush = adminDataQuery.data.data.filter(
        (d) => !prev.some((h) => h.id === d.id),
      );
      return [...prev, ...toPush];
    });
  }, [adminDataQuery.data]);

  // --- Mutation ---
  const bulkUpdateMutation = useBulkUpdateAdminFinMutation();

  const handleBulkUpdate = () => {
    if (selected.length === 0) return;

    bulkUpdateMutation.mutate(
      {
        selectedIds: selected,
        dataHistory: dataTableHistory,
        userNickname: user.nickname,
      },
      {
        onSuccess: () => {
          setOpenModalFinal(true);
          setSelected([]);
          setDataTableHistory([]);
          setOpenModal(true);
        },
        onError: (error) => {
          setMessageWarning("Error durante la actualización: " + error.message);
          setOpenModalFinal(false);
          setOpenModalWarning(true);
        },
      },
    );
  };

  useEffect(() => {
    if (!stateDataQuery.data || selectedStatus) return;
    const defaultStatus = stateDataQuery.data.find((s) => s.id === 1);
    setSelectedStatus(defaultStatus ?? stateDataQuery.data[0]);
  }, [stateDataQuery.data, selectedStatus]);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCloseModalWarning = () => {
    setOpenModalWarning(false);
    navigate("/service-operation/admin");
  };

  const handleRowClick = (rowData) => {
    navigate(`/service-operation/admin/${rowData.id}`);
  };

  const dataTableCount = adminDataQuery.data?.count ?? 0;

  // Solo skeleton completo en la carga inicial
  const isInitialLoading =  adminDataQuery.isLoading;
  // Refetch por filtros/paginación: solo afecta a la tabla
  const isFetching = adminDataQuery.isFetching || bulkUpdateMutation.isPending;

  const countPending = adminDataQuery.data?.countIngreso ?? 0;
  const countReparacion = adminDataQuery.data?.countReparacion ?? 0;

  if (isInitialLoading) {
    return <SkeletonsAdminPage />;
  }

  return (
    <Stack direction="column" spacing={2}>
      <Toolbar
        countPending={countPending}
        countReparacion={countReparacion}
        isLoading={isFetching}
        countryId={country.id}
      />

      {/* Chips de filtros activos */}
      <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mb: 2 }}>
        <StateFilterChip />
        <DateFilterChip />
      </Stack>
      <Stack>
        {openModalWarning && (
          <Alerta_Permisos_Services_Operation
            open={openModalWarning}
            CerrarModal={handleCloseModalWarning}
            icon={<Animation_Warning_animation />}
            message="¡Ups! Hubo un error"
            message2={messageWarning}
          />
        )}
        <Admin_Table
          country={country}
          onRowClick={handleRowClick}
          selected={selected}
          setSelected={setSelected}
          handleBulkUpdate={handleBulkUpdate}
        />
      </Stack>

      {openModalFinal && (
        <ModalConfirmEventos_ServicesOperation
          open={openModal}
          success={true}
          CerrarModal={handleCloseModal}
          icon={<Animation_Success_animation />}
          message="Se finalizaron los ticket correctamente!"
          message2={`Los reclamos pasaron a estado "Finalizado"`}
        />
      )}
    </Stack>
  );
};
export default Admin;
